/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { CloudPlatform } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class CloudService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get cloud connection mode
   *
   * LWM2M path: /1024//26
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getPlatform(): Promise<TapResponse<CloudPlatform>> {
    return this.serviceCallRunner.execute(this.getPlatformCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//26
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getPlatformCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPlatform };

    return callOptions;
  }

  /**
   * Write cloud connection mode
   *
   * LWM2M path: /1024//26
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putPlatform(
    /*
     *
     */
    key: CloudPlatform,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putPlatformCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//26
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putPlatformCall(
    /*
     *
     */
    key: CloudPlatform,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putPlatform };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Uploading period for the cloud
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getDataLogUploadPeriod(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getDataLogUploadPeriodCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getDataLogUploadPeriodCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDataLogUploadPeriod };

    return callOptions;
  }

  /**
   * Write cloud mqtt period
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putDataLogUploadPeriod(
    /*
     *
     */
    key: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putDataLogUploadPeriodCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putDataLogUploadPeriodCall(
    /*
     *
     */
    key: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putDataLogUploadPeriod };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get the cloud MQTT broker port
   *
   * LWM2M path: /1024//61
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMqttBrokerPort(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getMqttBrokerPortCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//61
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMqttBrokerPortCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMqttBrokerPort };

    return callOptions;
  }

  /**
   * Write cloud MQTT broker port
   *
   * LWM2M path: /1024//61
   *
   * @tapVersion(">=1.0")
   * @param name input
   * @return
   */
  putMqttBrokerPort(
    /*
     *
     */
    name: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putMqttBrokerPortCall(name));
  }

  /**
   *
   *
   * LWM2M path: /1024//61
   *
   * @tapVersion(">=1.0")
   * @param name input
   * @return call options
   */
  putMqttBrokerPortCall(
    /*
     *
     */
    name: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMqttBrokerPort };

    callOptions.body = name;

    return callOptions;
  }

  /**
   * Get cloud MQTT client id
   *
   * LWM2M path: /1024//27
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMqttClientId(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getMqttClientIdCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//27
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMqttClientIdCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMqttClientId };

    return callOptions;
  }

  /**
   * Write cloud MQTT client id
   *
   * LWM2M path: /1024//27
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putMqttClientId(
    /*
     *
     */
    value: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putMqttClientIdCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//27
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putMqttClientIdCall(
    /*
     *
     */
    value: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMqttClientId };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get cloud MQTT login id
   *
   * LWM2M path: /1024//28
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMqttUsername(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getMqttUsernameCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//28
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMqttUsernameCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMqttUsername };

    return callOptions;
  }

  /**
   * Write cloud MQTT login id
   *
   * LWM2M path: /1024//28
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putMqttUsername(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putMqttUsernameCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//28
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putMqttUsernameCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMqttUsername };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get cloud MQTT user password
   *
   * LWM2M path: /1024//29
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMqttPassword(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getMqttPasswordCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//29
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMqttPasswordCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMqttPassword };

    return callOptions;
  }

  /**
   * Write cloud MQTT user password
   *
   * LWM2M path: /1024//29
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putMqttPassword(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putMqttPasswordCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//29
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putMqttPasswordCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMqttPassword };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get cloud data log public topic
   *
   * LWM2M path: /1024//68
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getDataLogPublishTopic(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getDataLogPublishTopicCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//68
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getDataLogPublishTopicCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDataLogPublishTopic };

    return callOptions;
  }

  /**
   * Write cloud data log publish topic
   *
   * LWM2M path: /1024//68
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putDataLogPublishTopic(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putDataLogPublishTopicCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//68
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putDataLogPublishTopicCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putDataLogPublishTopic };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get cloud data log subscribe topic
   *
   * LWM2M path: /1024//69
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getDataLogSubscribeTopic(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getDataLogSubscribeTopicCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//69
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getDataLogSubscribeTopicCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDataLogSubscribeTopic };

    return callOptions;
  }

  /**
   * Write cloud data log subscribe topic
   *
   * LWM2M path: /1024//69
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putDataLogSubscribeTopic(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putDataLogSubscribeTopicCall(key),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//69
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putDataLogSubscribeTopicCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putDataLogSubscribeTopic };

    callOptions.body = key;

    return callOptions;
  }
}
